/**
 * Terms / Privacy / Disclaimer text.
 *
 * !!! DRAFT. Written as a starting point, NOT reviewed by a lawyer. The banner on each page stays visible until
 * LEGAL_REVIEWED is flipped to true after review (docs/PRD.md §14 question 11). Changing the text of a published
 * version means bumping TERMS_VERSION in packages/shared so every user is asked to accept again.
 */
export const LEGAL_REVIEWED = false

export type LegalSection = { h: string; p?: string[]; ul?: string[] }
export type LegalDoc = { title: string; sections: LegalSection[] }

export const LEGAL: Record<'syarat' | 'privasi' | 'disclaimer', LegalDoc> = {
  syarat: {
    title: 'Syarat & Ketentuan',
    sections: [
      { h: '1. Tentang IqraPath', p: ['IqraPath adalah aplikasi pendamping untuk memahami dan mengamalkan Al-Qur’an sedikit demi sedikit. IqraPath bukan lembaga fatwa dan bukan pengganti guru ngaji.'] },
      { h: '2. Akses dan lisensi', ul: [
        'Akses diberikan kepada pembeli melalui kode lisensi yang dikirim ke email pembelian.',
        'Lisensi bersifat pribadi. Jangan membagikan kode kepada orang lain.',
        'Kami dapat menonaktifkan lisensi yang disalahgunakan atau yang pembayarannya dikembalikan.',
      ] },
      { h: '3. Garansi', p: ['Kamu dapat meminta pengembalian dana dalam 7 hari sejak pembelian dengan menghubungi admin.'] },
      { h: '4. Penggunaan yang wajar', ul: [
        'Jangan menyalin, menjual ulang, atau mengambil isi aplikasi secara massal.',
        'Jangan mencoba mengganggu layanan atau mengakses data pengguna lain.',
      ] },
      { h: '5. Konten', p: ['Teks Arab dan terjemahan merujuk pada sumber yang dicantumkan di dalam aplikasi. Penjelasan dan renungan ditulis sebagai bahan belajar dan dapat diperbarui.'] },
      { h: '6. Perubahan', p: ['Syarat ini dapat diperbarui. Bila ada perubahan, kamu akan diminta menyetujui versi terbaru sebelum melanjutkan.'] },
    ],
  },
  privasi: {
    title: 'Kebijakan Privasi',
    sections: [
      { h: 'Data yang kami simpan', ul: [
        'Email pembelian dan nama (bila kamu mengisinya).',
        'Kemajuan belajar: ayat yang selesai, kebiasaan, tantangan.',
        'Catatan pribadi: jurnal, muhasabah, dan cerita ke Teman Cerita.',
        'Pengaturan, seperti jam pengingat dan ukuran huruf.',
        'Alamat notifikasi browser, bila kamu mengaktifkan pengingat. Dipakai hanya untuk mengirim pengingat, dan dihapus saat kamu keluar dari perangkat itu.',
      ] },
      { h: 'Catatanmu bersifat privat', p: ['Jurnal, muhasabah, dan cerita tidak dibaca tim kami, kecuali kamu sendiri melaporkan suatu jawaban. Jangan menuliskan data pribadi sensitif di kolom cerita.'] },
      { h: 'Pihak yang terlibat', ul: [
        'CloudPass: menerbitkan dan memeriksa lisensi, serta menyimpan bukti persetujuan syarat.',
        'Penyedia layanan AI: memproses isi cerita saat kamu memakai Teman Cerita.',
        'Penyedia email dan notifikasi: mengirim pesan yang kamu aktifkan. Isi notifikasi terenkripsi sampai ke perangkatmu (layanan notifikasi browser seperti Google, Apple, Mozilla, atau Microsoft hanya meneruskan).',
      ] },
      { h: 'Hak kamu', ul: ['Meminta salinan datamu.', 'Menghapus akun beserta seluruh datanya dari menu Pengaturan atau lewat admin.'] },
      { h: 'Keamanan', p: ['Kode lisensi disimpan terenkripsi. Koneksi dilindungi HTTPS.'] },
    ],
  },
  disclaimer: {
    title: 'Disclaimer',
    sections: [
      { h: 'Bahan renungan, bukan fatwa', p: ['Penjelasan, kartu, dan jawaban Teman Cerita adalah bahan renungan. Isinya bukan fatwa dan tidak menggantikan nasihat ustadz atau ulama.'] },
      { h: 'Soal hukum fikih', p: ['Untuk pertanyaan hukum (halal-haram, waris, dan sejenisnya), tanyakan langsung kepada ustadz atau lembaga yang berwenang.'] },
      { h: 'Sumber', p: ['Teks Arab dan terjemahan merujuk pada sumber yang dicantumkan di aplikasi, termasuk terjemahan Kemenag RI.'] },
      { h: 'Belajar membaca', p: ['Belajar dari aplikasi tidak menggantikan guru yang mengoreksi bacaanmu secara langsung.'] },
      { h: 'Saat hatimu sangat berat', p: ['Bila kamu merasa tidak sanggup atau ingin menyakiti diri sendiri, segera hubungi orang terdekat atau layanan darurat setempat. Aplikasi ini tidak dapat menggantikan bantuan profesional.'] },
    ],
  },
}

export type LegalSlug = keyof typeof LEGAL
export const isLegalSlug = (s: string | undefined): s is LegalSlug => s === 'syarat' || s === 'privasi' || s === 'disclaimer'
